import { useState, useEffect } from 'react'
import { consumirApi } from '../../../../utils/consumoApi'

const useCargaInicial = () => {
  const [tiposProyectoDatos, setTiposProyectoDatos] = useState([])
  const [espaciosDatos, setEspaciosDatos] = useState([])
  const [plazoElaboracionDatos, setPlazoElaboracionDatos] = useState([])
  const [idFormaPago, setIdFormaPago] = useState(2)
  const [formaPago, setFormaPago] = useState(null)
  const [formaPagoDatos, setFormaPagoDatos] = useState([])
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))

  // Ejecuta el manejador cuando `formaPagoDatos` cambie y ya tenga datos
  useEffect(() => {
    if (formaPagoDatos.length > 0 && idFormaPago) {
      manejadorFormaPago(idFormaPago)
    }
  }, [formaPagoDatos, idFormaPago])

  // Obtener tipos de proyecto
  const obtenerTipoProyecto = async () => {
    const respuesta = await consumirApi('GET', `maestros/tipo-proyecto/${idEmpresa}`)
    setTiposProyectoDatos(respuesta.data)
  }

  // Obtener formas de pago
  const obtenerEspacio = async () => {
    const respuesta = await consumirApi('GET', `maestros/espacio/${idEmpresa}`)
    setEspaciosDatos(respuesta.data)
  }

  // Obtener formas de pago
  const obtenerFormaPago = async () => {
    const respuesta = await consumirApi('GET', `maestros/forma-pago-detalle/${idEmpresa}` )
    setFormaPagoDatos(respuesta.data)
    // manejadorFormaPago(idFormaPago)
  }

  // Manejador para el cambio de forma de pago
  const manejadorFormaPago = (idFormaPago) => {
    if (idFormaPago !== '') {
      setIdFormaPago(idFormaPago)
      // carga solo los datos de la forma de pago seleccionada para que sea usada para generar las cuotas de los paquete s
      const formaPagoSeleccionado = formaPagoDatos.find((formaPago) => formaPago.id == idFormaPago)
      setFormaPago(formaPagoSeleccionado)
    }
  }  

  // Obtener plazos de elaboracion
  const obtenerPlazoElaboracion = async () => {
    const respuesta = await consumirApi('GET', `maestros/plazo/${idEmpresa}`)
    setPlazoElaboracionDatos(respuesta.data)
  }

  useEffect(() => {
    obtenerTipoProyecto()
    obtenerEspacio()
    obtenerPlazoElaboracion()
    obtenerFormaPago()

  }, []) // Solo ejecuta una vez cuando el componente se monta

  return {
    tiposProyectoDatos,
    espaciosDatos,
    plazoElaboracionDatos,
    idFormaPago,
    formaPago,
    setIdFormaPago,
    manejadorFormaPago
  }
}

export default useCargaInicial
